import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '@/components/Header';
import { FlowNavigation } from '@/components/FlowNavigation';
import { useAuth } from '@/contexts/AuthContext';
import MenuBookIcon from '@/assets/icons/menu-book-white.svg?react';
import './FixedSeatGuide.scss';

export function FixedSeatGuide() {
    const navigate = useNavigate();
    const { user, checkAuth } = useAuth();
    const fixedSeats = user?.fixedStudySeats ?? [];

    useEffect(() => {
        let isMounted = true;

        const verifyFixedSeat = async () => {
            const refreshedUser = await checkAuth({ showLoading: false });

            if (!isMounted) {
                return;
            }

            if (refreshedUser?.serviceAccess?.studyCafeEnabled === false) {
                navigate('/study-cafe/access-restricted', { replace: true });
                return;
            }

            if ((refreshedUser?.fixedStudySeats?.length ?? 0) === 0) {
                navigate('/study-cafe', { replace: true });
            }
        };

        verifyFixedSeat();

        return () => {
            isMounted = false;
        };
    }, [checkAuth, navigate]);

    return (
        <div className="fixed-seat-guide-page">
            <Header />

            <main className="fixed-seat-guide-main">
                <div className="fixed-seat-guide-card">
                    <div className="fixed-seat-guide-card__icon">
                        <MenuBookIcon className="icon-svg" />
                    </div>
                    <h1>오늘의 고정좌석 안내</h1>
                    <p>오늘 고정좌석이 지정된 학생은 스터디카페 일반 예약을 이용할 수 없습니다.</p>
                    {fixedSeats.length > 0 && (
                        <div className="fixed-seat-guide-card__seats">
                            <strong>오늘의 고정좌석</strong>
                            <ul>
                                {fixedSeats.map((seat) => (
                                    <li key={seat.seatId}>{seat.seatName}번</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </main>

            <FlowNavigation
                onPrev={() => navigate('/selection')}
                onNext={() => { }}
                hideNextButton
            />
        </div>
    );
}
